var _defs, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 83,
    cy: 86.91,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 86.91,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,67.91H12c-2.76,0-5,2.24-5,5v5h8.5v4.52c-1.88.63-3.25,2.39-3.25,4.48,0,2.62,2.13,4.75,4.75,4.75s4.75-2.13,4.75-4.75c0-2.09-1.37-3.85-3.25-4.48v-4.52h63v4.52c-1.88.63-3.25,2.39-3.25,4.48,0,2.62,2.13,4.75,4.75,4.75s4.75-2.13,4.75-4.75c0-2.09-1.37-3.85-3.25-4.48v-4.52h8.5v-5c0-2.76-2.24-5-5-5ZM20.25,86.91c0,1.79-1.46,3.25-3.25,3.25s-3.25-1.46-3.25-3.25,1.46-3.25,3.25-3.25,3.25,1.46,3.25,3.25ZM86.25,86.91c0,1.79-1.46,3.25-3.25,3.25s-3.25-1.46-3.25-3.25,1.46-3.25,3.25-3.25,3.25,1.46,3.25,3.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88,55.91h-16.62v-28.5h3.1c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-3.1v-3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5v3.5h-10.4v5.5h-.5c-1.1,0-2,.9-2,2v11c0,1.1.9,2,2,2h.51s0,.05,0,.08c0,.07.29,6.75-3.06,10.27-.23.24-.47.45-.72.65h-19.1c1.17-2.5.08-5.48-2.42-6.64l-9.97-4.65c-2.5-1.17-5.48-.08-6.64,2.42l-.35-.16c-2.5-1.17-5.48-.08-6.64,2.42-1.17,2.5-.08,5.48,2.42,6.64l20.39,9.51s.05.02.07.03c.18.08.37.14.56.2.13.04.26.09.39.12.15.03.31.04.47.06.18.02.35.05.53.05.03,0,.06,0,.09,0h54c2.76,0,5-2.24,5-5h0c0-2.76-2.24-5-5-5ZM60.98,44.91h.5c1.1,0,2-.9,2-2v-11c0-1.1-.9-2-2-2h-.5v-2.5h7.4v28.5h-10.16c2.94-4.34,2.8-10.3,2.77-11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause6);
export default __webpack_public_path__ + "static/media/cause_6.4a1c1b26106efa1ffe4c5a79b5d376f6.svg";
export { ForwardRef as ReactComponent };